import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { modififyDropdownServiceNameList } from "../../../../../services/fetchDropdownListData";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { removeServiceData } from "../../../../../data/redux/slice/addService";

const TypeService = ({ onClickNext, onClickCancel, clientDetails }) => {
  const [industry, setIndustry] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [serviceProviderName, setServiceProviderName] = useState("");
  const [payinServiceList, setPayinServiceList] = useState([]);
  const [payoutServiceList, setPayoutServiceList] = useState([]);
  const [vanServiceList, setVanServiceList] = useState([]);
  const [voucherServiceList, setVoucherServiceList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.addService);
  const [equitasVanUpiServiceList, setEquitasVanUpiServiceList] = useState([]);
  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  const ServiceTypes = [
    {
      label: "Payin",
      value: "payin",
    },
    {
      label: "Payout",
      value: "payout",
    },
    {
      label: "VAN Payin",
      value: "van",
    },
    {
      label: "Voucher",
      value: "voucher",
    },
    {
      label: "VAN Upi",
      value: "van-upi",
    },
  ];

  const clientService = clientDetails?.service;
  let clientServices = [];
  clientService.map((e) => {
    clientServices.push(e?.serviceType);
  });

  const filterdServiceTypes = ServiceTypes?.filter(
    (service) => !clientServices.includes(service.value)
  );

  const fetchPayinDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payin",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };

  const fetchPayoutDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payout",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayoutServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };
  const fetchVanDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "van",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setVanServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };
  const fetchVoucherDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "voucher",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setVoucherServiceList(modififyDropdownServiceNameList(res.data));
        }
      })
      .catch((err) => {});
  };

  const fetchVanUpiDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "van-upi",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setEquitasVanUpiServiceList(
            modififyDropdownServiceNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };
  function getValue(arr, finder) {
    return arr.find((data) => data?.value === finder);
  }

  function getLabel(arr, finder) {
    return arr.find((data) => data?.label === finder);
  }

  useEffect(() => {
    fetchPayinDropDown();
    fetchPayoutDropDown();
    fetchVanDropDown();
    fetchVoucherDropDown();
    fetchVanUpiDropDown();
  }, []);

  useEffect(() => {
    if (
      reduxData?.service?.serviceType &&
      reduxData?.service?.serviceProviderName
    ) {
      setServiceType(getValue(ServiceTypes, reduxData?.service?.serviceType));

      if (serviceType.value === "payin") {
        setServiceProviderName(
          getLabel(payinServiceList, reduxData?.service?.serviceProviderName)
        );
      } else if (serviceType.value === "payout") {
        setServiceProviderName(
          getLabel(payoutServiceList, reduxData?.service?.serviceProviderName)
        );
      } else if (serviceType.value === "van") {
        setServiceProviderName(
          getLabel(vanServiceList, reduxData?.service?.serviceProviderName)
        );
      } else if (serviceType.value === "voucher") {
        setServiceProviderName(
          getLabel(voucherServiceList, reduxData?.service?.serviceProviderName)
        );
      } else if (serviceType.value === "van-upi") {
        setServiceProviderName(
          getLabel(
            equitasVanUpiServiceList,
            reduxData?.service?.serviceProviderName
          )
        );
      }
    }
  }, [reduxData, payoutServiceList, vanServiceList]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
      }}
    >
      <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
        <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
          Service Type
        </label>
        <div style={{ maxWidth: "350px" }}>
          <CustomSelect
            placeholder="Select Service Type"
            style={{
              ...containerStyle,
              position: "",
            }}
            value={serviceType}
            options={filterdServiceTypes}
            onChange={(data) => {
              setServiceType(data);
              setServiceProviderName("");
              dispatch(removeServiceData());
            }}
          />
        </div>
      </div>
      <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
        <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
          Service Provider
        </label>
        <div style={{ maxWidth: "350px" }}>
          <CustomSelect
            disabled={serviceType === "" ? true : false}
            placeholder="Select Service Provider"
            style={{
              ...containerStyle,
              position: "",
            }}
            value={serviceProviderName}
            options={
              serviceType?.value === "payin"
                ? payinServiceList
                : serviceType?.value === "payout"
                ? payoutServiceList
                : serviceType?.value === "van"
                ? vanServiceList
                : serviceType?.value === "voucher"
                ? voucherServiceList
                : serviceType?.value === "van-upi"
                ? equitasVanUpiServiceList
                : ""
            }
            onChange={(data) => {
              setServiceProviderName(data);
            }}
          />
        </div>
      </div>
      <div style={{ display: "flex", maxWidth: "340px" }}>
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 40px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              const clientService = clientDetails?.service;

              for (const servicesOfClient of clientService) {
                if (
                  servicesOfClient?.serviceType?.toLowerCase() ===
                  serviceType?.value?.toLowerCase()
                ) {
                  enqueueSnackbar("Client already have this service", {
                    variant: "error",
                  });
                  return;
                }

                if (
                  servicesOfClient?.serviceType?.toLowerCase() === "payout" &&
                  servicesOfClient?.serviceType?.toLowerCase() === "payin" &&
                  servicesOfClient?.serviceType?.toLowerCase() === "van" &&
                  servicesOfClient?.serviceType?.toLowerCase() === "voucher"
                ) {
                  enqueueSnackbar("Client already have all service providers", {
                    variant: "error",
                  });
                  return;
                }

                if (
                  servicesOfClient?.serviceType?.toLowerCase() ===
                    serviceType?.value?.toLowerCase() &&
                  servicesOfClient?.serviceProviderName?.toLowerCase() ===
                    serviceProviderName?.value?.toLowerCase()
                ) {
                  enqueueSnackbar("Client already have this service provider", {
                    variant: "error",
                  });
                  return;
                }
              }

              if (serviceType !== "" && serviceProviderName !== "") {
                onClickNext({
                  service: {
                    ...reduxData.service,
                    serviceType: serviceType.value,
                    serviceProviderName: serviceProviderName?.value,
                    serviceProviderRate: serviceProviderName?.rate,
                  },
                });
              } else {
                if (serviceType === "") {
                  enqueueSnackbar("Please select Service type", {
                    variant: "error",
                  });
                } else if (serviceProviderName === "") {
                  enqueueSnackbar("Please select Service provider", {
                    variant: "error",
                  });
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TypeService;

const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content",
  },
  p: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
};
